<template>
  <div>
    <v-dialog
      v-model="show"
    >
      <v-card>
        <v-card-title class="third white--text font-weight-bold">
          <span class="ml-2">Demande</span>
          <v-spacer />
          <v-btn icon color="white" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text v-if="customer" class="card-body mt-2">
          <!-- user info -->
          <v-row no-gutters>
            <v-col cols="3">
              <v-list-item-subtitle>Prénom</v-list-item-subtitle>
              <v-list-item-title>{{ customer.firstname }}</v-list-item-title>
            </v-col>
            <v-col cols="3">
              <v-list-item-subtitle>Nom</v-list-item-subtitle>
              <v-list-item-title>{{ customer.lastname }}</v-list-item-title>
            </v-col>
            <v-col cols="3">
              <v-list-item-subtitle>email</v-list-item-subtitle>
              <v-list-item-title>{{ customer.email }}</v-list-item-title>
            </v-col>
            <v-col cols="3">
              <v-list-item-subtitle>Mobile Tél</v-list-item-subtitle>
              <v-list-item-title>{{ customer.mobilephone }}</v-list-item-title>
            </v-col>
            <v-col cols="6" class="mt-1">
              <v-list-item-subtitle>Statut</v-list-item-subtitle>
              <v-list-item-title v-if="isAcceptedOrRejected">{{ statusText }}</v-list-item-title>
              <v-list-item-title v-else>En cours</v-list-item-title>
            </v-col>
          </v-row>
          <!-- user request -->
          <v-row>
            <v-list-item-subtitle>Justification de l'utilisateur</v-list-item-subtitle>
            <v-list-item-title>
              <v-textarea
                v-model="customer.justification"
                filled
                placeholder="Justification de l'utilisateur"
                rows="4"
                row-height="30"
                hide-details
                no-resize
                color="third"
                readonly
              />
            </v-list-item-title>
          </v-row>
          <!-- monitor response or text area to fill -->
          <!-- monitor response -->
          <v-row>
            <v-list-item-subtitle>Justification du moniteur</v-list-item-subtitle>
            <v-list-item-title>
              <v-textarea
                v-if="isTreated"
                v-model="customer.monitor_justification"
                filled
                placeholder="Justification du moniteur"
                rows="4"
                row-height="30"
                hide-details
                no-resize
                color="third"
                readonly
              />
              <v-textarea
                v-else
                v-model="monitorJustification"
                filled
                placeholder="Justification du moniteur"
                rows="4"
                row-height="30"
                hide-details
                no-resize
                color="third"
              />
            </v-list-item-title>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <!-- accept adn reject button or delete button -->
          <div v-if="!isTreated">
            <v-btn color="success" :disabled="!monitorJustification" @click="accept">Accepter</v-btn>
            <v-btn class="ml-2" :disabled="!monitorJustification" color="error" @click="reject">Refuser</v-btn>
          </div>
          <div v-else>
            <v-btn color="error" @click="showConfirmationModal = !showConfirmationModal">Supprimer</v-btn>
          </div>
          <v-btn class="ml-2" color="info" @click="closeModal">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmationModal style="z-index: 100000;" title="Supprimer le demande" :activator.sync="showConfirmationModal" :close-modal="closeConfirmationModal" :action="deleteRequest">
      <template #body>
        <h3 class="black--text">
          Êtes-vous sûr de vouloir supprimer la demande
        </h3>
      </template>
    </ConfirmationModal>
  </div>
</template>

<script>
import { ref, inject, computed } from '@vue/composition-api';
import { EventBus, formatDate } from '../../helpers/utils';
import ConfirmationModal from '../common/ConfirmationModal.vue';

export default {
  components: { ConfirmationModal },
  setup () {
    const show = ref(false);
    const isTreated = ref(false);
    const customer = ref(null);
    const monitorJustification = ref(null);
    const showConfirmationModal = ref(false);

    const deleteOnDemand = inject('deleteOnDemand');
    const handleRequest = inject('handleRequest');

    const closeModal = () => {
      monitorJustification.value = null;
      show.value = false;
    };

    const closeConfirmationModal = () => {
      showConfirmationModal.value = false;
    };

    EventBus.$on('show-on-demand-modal', modalInfo => {
      show.value = true;
      isTreated.value = modalInfo.editing;
      customer.value = modalInfo.item;
    });

    const statusText = computed(() => {
      if (customer.value) {
        const date = customer.value.updated_at ? formatDate(customer.value.updated_at, 'dd/MM/yyyy') : '';
        const hour = customer.value.updated_at ? formatDate(customer.value.updated_at, "HH'h'mm") : '';
        return `La demande a été ${customer.value.status.label} le ${date} à ${hour} par moniteur 1`;
      }
      return '';
    });

    const isAcceptedOrRejected = computed(() => customer.value && (customer.value.status.value === 'ACCEPTED' || customer.value.status.value === 'REJECTED'));

    const accept = () => {
      handleRequest(customer.value, monitorJustification.value, 'ACCEPTED');
      closeModal();
    };

    const reject = () => {
      handleRequest(customer.value, monitorJustification.value, 'REJECTED');
      closeModal();
    };

    const deleteRequest = () => {
      deleteOnDemand(customer.value);
      closeModal();
      closeConfirmationModal();
    };

    return { closeConfirmationModal, showConfirmationModal, accept, reject, deleteRequest, show, isTreated, closeModal, customer, monitorJustification, statusText, isAcceptedOrRejected };
  }
};
</script>
